import { createSlice } from "@reduxjs/toolkit";
import { fetchConfigurations } from "./configurationThunk";

const initialState = {
    data: {},
    loading: false,
    error: null,
};

const configurationSlice = createSlice({
    name: "configuration",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchConfigurations.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchConfigurations.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;

                // optional cache
                localStorage.setItem(
                    "config",
                    JSON.stringify(state.data)
                );
            })
            .addCase(fetchConfigurations.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default configurationSlice.reducer;
